export function defaultFiscalDate(fiscalYear, today = new Date()) {
  const localDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
  return localDate < `${fiscalYear}-01-01` ? `${fiscalYear}-01-01`
    : localDate > `${fiscalYear}-12-31` ? `${fiscalYear}-12-31` : localDate;
}

export function validatePeriod(accountId, fromDate, toDate, fiscalYear) {
  if (!accountId) return "Zgjidhni arkën.";
  const validDate = (value) => /^\d{4}-\d{2}-\d{2}$/.test(value) &&
    Number.isFinite(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value;
  if (!validDate(fromDate) || !validDate(toDate)) return "Plotësoni të dy datat.";
  if (fromDate < `${fiscalYear}-01-01` || toDate > `${fiscalYear}-12-31` || toDate < fromDate)
    return "Periudha duhet të jetë brenda vitit fiskal, me datat në rend të saktë.";
  if ((Date.parse(toDate) - Date.parse(fromDate)) / 86400000 > 31)
    return "Zgjidhni deri në 32 ditë përfshirëse.";
  return "";
}

const cents = (value) => {
  if (value === "" || value === null || value === undefined || !Number.isFinite(Number(value))) return null;
  return Math.round((Number(value) + Number.EPSILON) * 100);
};

export function calculateCashDraft(netMovement, opening, counted, retained) {
  const movement = cents(netMovement);
  const initial = cents(opening);
  const actual = cents(counted);
  const reserve = cents(retained);
  const expected = movement !== null && initial !== null && initial >= 0 ? movement + initial : null;
  return {
    expected: expected === null ? null : expected / 100,
    difference: expected !== null && actual !== null && actual >= 0 ? (actual - expected) / 100 : null,
    handover: actual !== null && reserve !== null && actual >= 0 && reserve >= 0 && reserve <= actual
      ? (actual - reserve) / 100 : null,
    error: actual !== null && reserve !== null && reserve > actual
      ? "Shuma që mbetet nuk mund të jetë më e madhe se paratë e numëruara." : "",
  };
}

export function normalizePreview(data, accountId) {
  if (!data || Number(data.AccountID) !== Number(accountId) ||
      !Number.isInteger(data.EntryCount) || data.EntryCount < 0 ||
      typeof data.TotalDebit !== "number" || !Number.isFinite(data.TotalDebit) ||
      typeof data.TotalCredit !== "number" || !Number.isFinite(data.TotalCredit))
    throw new Error("Përmbledhja e arkës nuk ktheu të dhëna valide.");
  return { ...data, NetMovement: data.TotalDebit - data.TotalCredit };
}
